import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function EmpList(){

  const [empData, setempData] = useState([]);

  useEffect(() => {
    fetchempData();
  }, []);

  function fetchempData() {
        const url = `${baseUrl}add-employee/`;
        axios.get(url)
          .then(response => {
            setempData(response.data);
          })
          .catch(error => {
            console.log(error);
          });
  }

    const columns = [
        { field: 'delete', headerName: 'Delete',
          renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} style={{color:'red'}}>
          <i className="fa-solid fa-trash-can"></i></button>
          ),
          width: 30,
          sortable: false,
          filterable: false,
          disableColumnMenu: true,
        },
        { field: 'edit', headerName: 'Edit',
          renderCell: (params) => (
              <Link to={`/edit-emp/${params.row.id}/`} >
                <i className="fa-solid fa-pen-to-square"></i>
              </Link>
          ),
          width: 30,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        },
        {field:'emp_id', headerName:'Emp ID',
          renderCell: (params) => (
              <Link to={`/emp-view/${params.row.id}/`}>
                {params.value}
              </Link>
          ),
          width: 80,
          },
        {field:'emp_code', headerName:'Emp Code',
            renderCell: (params) => (
              <Link to={`/emp-view/${params.row.id}/`}>
                {params.value}
              </Link>
          ),
          width:120
        },
        {field:'employee', headerName:'Employee', width:130},
        {field:'age', headerName:'Age', width:10},
        {field:'mobile', headerName:'Mobile', width:100},
        {field:'address', headerName:'Address', width:120},
        {
          field: 'department',
          headerName: 'Department',
          width: 120,
          renderCell: (params) => {
            return params.row?.department?.department || '';
          },
        },
        {
          field: 'designation',
          headerName: 'Designation',
          width: 130,
          renderCell: (params) => {
            return params.row?.designation?.designation || '';
          },
        },

        {field:'emp_status', headerName:'Emp Status', width:100},
        {field:'doj', headerName:'Joining Date', width:100},
        { field: 'payslip', headerName: 'Gen Payslip',
          renderCell: (params) => (
              <Link to={`/generate-payslip/${params.row.id}/`} className="btn btn-warning">
                <i className="fa-solid fa-money-bill"></i>
              </Link>
          ),
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        },
      ];
      const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-emp/'+id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                      window.location.reload();
                    });
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
    return (
    <section className="container mt-4">
    <div className="row">
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
          <i className="fa-solid fa-list" aria-hidden="true" style={{ color: 'red' }}></i>
          Employee List
    </h3>
    {empData.length > 0 ? (
        <div style={{ height: '100%', width: '100%' }} className="mt-4">
            <DataGrid
            sx={{
            boxShadow: 4,
            border: 4,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            }}
            rows= {empData}
            columns= {columns}
            pageSize= {10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
            />
        </div>
    ) : (
      <></>
    )}
    </div>
    </section>
    )
}

export default EmpList;
